
import { useEffect, useState } from "react";

import {
    Box,
    Container,
    Grid,
    Typography,
    Card,
    CardContent,
    CardMedia,
    Chip,
    Pagination,
    Stack,
    Button,
    Dialog,
    DialogContent,
    IconButton,
    Divider,
    CircularProgress,
} from "@mui/material";

import {
    ArrowForward,
    CalendarMonthOutlined,
    CloseRounded,
} from "@mui/icons-material";

import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";

import { useComunidadPublica } from "../../hooks/UseComunidad";

import { formatearFecha } from "../../utils/FormatoFecha";

import colegio from "../../assets/img/antilllen.png";


const backendURL = process.env.REACT_APP_BACKEND_URL;


// ======================================================
// COLORES SEGÚN TIPO
// ======================================================

const coloresTipo = {

    importante: "#D32F2F",

    recordatorio: "#3DA65C",

    informativo: "#2F3F83",

  

};


// ======================================================
// NOMBRE VISIBLE DEL TIPO
// ======================================================

const nombresTipo = {

    importante: "IMPORTANTE",

    recordatorio: "RECORDATORIO",

    informativo: "INFORMATIVO",

   

};


// ======================================================
// COMPONENTE
// ======================================================

export const SliderComunicado = () => {


    // ==================================================
    // HOOK
    // ==================================================

    const {
        comunidades,
        loading,
        error,
        cargarComunidadPublica,
    } = useComunidadPublica();


    // ==================================================
    // ESTADOS
    // ==================================================

    const [
        comunicadoSeleccionado,
        setComunicadoSeleccionado,
    ] = useState(null);


    const [page, setPage] = useState(1);


    // ==================================================
    // CARGAR INFORMACIÓN
    // ==================================================

    useEffect(() => {

        cargarComunidadPublica();

    }, []);


    // ==================================================
    // ABRIR MODAL
    // ==================================================

    const handleOpenDialog = (item) => {

        setComunicadoSeleccionado(item);

    };


    // ==================================================
    // CERRAR MODAL
    // ==================================================

    const handleCloseDialog = () => {

        setComunicadoSeleccionado(null);

    };


    // ==================================================
    // OBTENER COLOR DEL TIPO
    // ==================================================

    const obtenerColorTipo = (tipo) => {

        return (
            coloresTipo[
                tipo?.toLowerCase()
            ] || "#561C33"
        );

    };


    // ==================================================
    // OBTENER NOMBRE DEL TIPO
    // ==================================================

    const obtenerNombreTipo = (tipo) => {

        return (
            nombresTipo[
                tipo?.toLowerCase()
            ] ||
            tipo?.toUpperCase() ||
            "COMUNICADO"
        );

    };


    // ==================================================
    // OBTENER IMAGEN
    // ==================================================

    const obtenerImagen = (item) => {

        if (!item?.imagen) {

            return colegio;

        }

        return `${backendURL}/${item.imagen}`;

    };


    // ==================================================
    // PAGINACIÓN
    // ==================================================

    const itemsPerPage = 6;


    const totalPages = Math.ceil(
        comunidades.length / itemsPerPage
    );


    const comunicadosPagina =
        comunidades.slice(
            (page - 1) * itemsPerPage,
            page * itemsPerPage
        );


    // ==================================================
    // CAMBIO DE PÁGINA
    // ==================================================

    const handleChangePage = (
        event,
        value
    ) => {

        setPage(value);

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

    };


    // ==================================================
    // LOADING
    // ==================================================

    if (loading) {

        return (

            <Box py={8}>

                <Container maxWidth="xl">

                    <Box
                        sx={{
                            minHeight: 400,

                            display: "flex",

                            alignItems: "center",

                            justifyContent: "center",
                        }}
                    >

                        <CircularProgress
                            sx={{
                                color: "#561C33",
                            }}
                        />

                    </Box>

                </Container>

            </Box>

        );

    }


    // ==================================================
    // ERROR
    // ==================================================

    if (error) {

        return (

            <Box py={8}>

                <Container maxWidth="xl">

                    <Typography
                        sx={{
                            textAlign: "center",

                            color: "#777",

                            fontWeight: 600,
                        }}
                    >
                        No fue posible cargar las comunicaciones.
                    </Typography>

                </Container>

            </Box>

        );

    }


    // ==================================================
    // SIN INFORMACIÓN
    // ==================================================

    if (!comunidades.length) {

        return (

            <Box py={8}>

                <Container maxWidth="xl">

                    <Box
                        sx={{
                            py: 8,

                            textAlign: "center",

                            bgcolor: "#fafafa",

                            borderRadius: "24px",
                        }}
                    >

                        <Typography
                            sx={{
                                color: "#777",

                                fontWeight: 600,
                            }}
                        >
                            No hay comunicaciones disponibles.
                        </Typography>

                    </Box>

                </Container>

            </Box>

        );

    }


    // ==================================================
    // RENDER
    // ==================================================

    return (

        <Box py={8}>

            <Container maxWidth="xl">


                {/* ==================================================
                    HEADER
                ================================================== */}

                <Box
                    sx={{
                        mb: 5,

                        display: "flex",

                        justifyContent:
                            "space-between",

                        alignItems: "center",

                        flexWrap: "wrap",

                        gap: 2,
                    }}
                >

                    <Stack
                        direction="row"
                        spacing={2}
                        alignItems="center"
                    >

                        <Box
                            sx={{
                                width: 58,

                                height: 58,

                                bgcolor: "#fff",

                                borderRadius: "50%",

                                display: "flex",

                                justifyContent:
                                    "center",

                                alignItems:
                                    "center",

                                boxShadow:
                                    "0 8px 20px rgba(0,0,0,.08)",
                            }}
                        >

                            <CampaignOutlinedIcon
                                sx={{
                                    color: "#561C33",

                                    fontSize: 30,
                                }}
                            />

                        </Box>


                        <Typography
                            sx={{
                                color: "#561C33",

                                fontWeight: 700,

                                fontSize: {
                                    xs: "1rem",
                                    md: "1.3rem",
                                },
                            }}
                        >
                            Comunicaciones recientes
                        </Typography>

                    </Stack>

                </Box>


                {/* ==================================================
                    CARDS
                ================================================== */}

                <Grid
                    container
                    spacing={4}
                >

                    {comunicadosPagina.map(
                        (item) => {

                            const color =
                                obtenerColorTipo(
                                    item.tipo
                                );


                            const nombreTipo =
                                obtenerNombreTipo(
                                    item.tipo
                                );


                            const imagen =
                                obtenerImagen(
                                    item
                                );


                            return (

                                <Grid
                                    key={item.id}
                                    size={{
                                        xs: 12,
                                        sm: 6,
                                        lg: 4,
                                    }}
                                >

                                    <Card
                                        sx={{
                                            height:
                                                "100%",

                                            borderRadius:
                                                "22px",

                                            overflow:
                                                "hidden",

                                            display:
                                                "flex",

                                            flexDirection:
                                                "column",

                                            transition:
                                                "transform .35s, box-shadow .35s",

                                            "&:hover":
                                                {
                                                    transform:
                                                        "translateY(-8px)",

                                                    boxShadow:
                                                        "0 20px 45px rgba(0,0,0,.12)",
                                                },
                                        }}
                                    >


                                        {/* ==========================================
                                            IMAGEN
                                        ========================================== */}

                                        <Box
                                            sx={{
                                                position:
                                                    "relative",
                                            }}
                                        >

                                            <CardMedia
                                                component="img"

                                                image={
                                                    imagen
                                                }

                                                alt={
                                                    item.titulo
                                                }

                                                sx={{
                                                    height:
                                                        {
                                                            xs: 200,
                                                            md: 220,
                                                        },

                                                    objectFit:
                                                        "cover",
                                                }}

                                                onError={(
                                                    event
                                                ) => {

                                                    event.currentTarget.src =
                                                        colegio;

                                                }}
                                            />


                                            {/* DEGRADADO */}

                                            <Box
                                                sx={{
                                                    position:
                                                        "absolute",

                                                    inset: 0,

                                                    background:
                                                        "linear-gradient(180deg, rgba(0,0,0,0) 45%, rgba(0,0,0,.45) 100%)",
                                                }}
                                            />


                                            {/* ==========================================
                                                TIPO
                                            ========================================== */}

                                            <Chip
                                                label={
                                                    nombreTipo
                                                }

                                                sx={{
                                                    position:
                                                        "absolute",

                                                    top: 15,

                                                    left: 15,

                                                    bgcolor:
                                                        color,

                                                    color:
                                                        "#fff",

                                                    fontWeight:
                                                        700,

                                                    fontSize:
                                                        ".72rem",

                                                    textTransform:
                                                        "uppercase",

                                                    boxShadow:
                                                        "0 4px 12px rgba(0,0,0,.18)",
                                                }}
                                            />

                                        </Box>


                                        {/* ==========================================
                                            CONTENIDO
                                        ========================================== */}

                                        <CardContent
                                            sx={{
                                                p: 3,

                                                display:
                                                    "flex",

                                                flexDirection:
                                                    "column",

                                                flexGrow: 1,
                                            }}
                                        >


                                            {/* FECHA */}

                                            {item.fecha && (

                                                <Stack
                                                    direction="row"
                                                    spacing={1}
                                                    alignItems="center"
                                                    mb={2}
                                                >

                                                    <CalendarMonthOutlined
                                                        sx={{
                                                            color:
                                                                "#777",

                                                            fontSize:
                                                                18,
                                                        }}
                                                    />

                                                    <Typography
                                                        color="text.secondary"
                                                        fontSize={
                                                            14
                                                        }
                                                    >
                                                        {formatearFecha(
                                                            item.fecha
                                                        )}
                                                    </Typography>

                                                </Stack>

                                            )}


                                            {/* TÍTULO */}

                                            <Typography
                                                sx={{
                                                    fontWeight:
                                                        700,

                                                    color:
                                                        "#2c2c2c",

                                                    mb: 1,

                                                    lineHeight:
                                                        1.3,

                                                    display:
                                                        "-webkit-box",

                                                    WebkitLineClamp:
                                                        2,

                                                    WebkitBoxOrient:
                                                        "vertical",

                                                    overflow:
                                                        "hidden",
                                                }}
                                            >
                                                {
                                                    item.titulo
                                                }
                                            </Typography>


                                            {/* DESCRIPCIÓN */}

                                            <Typography
                                                sx={{
                                                    color:
                                                        "#666",

                                                    mb: 3,

                                                    lineHeight:
                                                        1.7,

                                                    display:
                                                        "-webkit-box",

                                                    WebkitLineClamp:
                                                        3,

                                                    WebkitBoxOrient:
                                                        "vertical",

                                                    overflow:
                                                        "hidden",

                                                    flexGrow:
                                                        1,
                                                }}
                                            >
                                                {
                                                    item.pie_portada ||
                                                    item.descripcion ||
                                                    "Revisa la información de esta comunicación."
                                                }
                                            </Typography>


                                            {/* BOTÓN */}

                                            <Button
                                                onClick={() =>
                                                    handleOpenDialog(
                                                        item
                                                    )
                                                }

                                                endIcon={
                                                    <ArrowForward />
                                                }

                                                sx={{
                                                    color:
                                                        color,

                                                    fontWeight:
                                                        700,

                                                    textTransform:
                                                        "none",

                                                    p: 0,

                                                    width:
                                                        "fit-content",

                                                    "&:hover":
                                                        {
                                                            bgcolor:
                                                                "transparent",
                                                        },
                                                }}
                                            >
                                                Leer más
                                            </Button>

                                        </CardContent>

                                    </Card>

                                </Grid>

                            );

                        }
                    )}

                </Grid>


                {/* ==================================================
                    PAGINACIÓN
                ================================================== */}

                {totalPages > 1 && (

                    <Box
                        sx={{
                            mt: 6,

                            display: "flex",

                            justifyContent:
                                "center",
                        }}
                    >

                        <Pagination
                            page={page}

                            count={
                                totalPages
                            }

                            onChange={
                                handleChangePage
                            }

                            color="primary"

                            shape="rounded"

                            size="large"
                        />

                    </Box>

                )}

            </Container>


            {/* ==================================================
                MODAL
            ================================================== */}

            <Dialog
                open={
                    Boolean(
                        comunicadoSeleccionado
                    )
                }

                onClose={
                    handleCloseDialog
                }

                fullWidth

                maxWidth="md"

                scroll="paper"

                PaperProps={{
                    sx: {

                        borderRadius: {
                            xs: "18px",
                            sm: "26px",
                        },

                        overflow:
                            "hidden",

                        width: {
                            xs: "calc(100% - 20px)",
                            sm: "90%",
                        },

                        maxHeight: {
                            xs: "92vh",
                            md: "88vh",
                        },
                    },
                }}
            >

                {comunicadoSeleccionado && (

                    <>

                        {/* ==================================================
                            IMAGEN
                        ================================================== */}

                        <Box
                            sx={{
                                position:
                                    "relative",

                                height: {
                                    xs: "100%",
                                    sm: "100%",
                                    md: "100%",
                                },

                                overflow:
                                    "hidden",
                            }}
                        >

                            <Box
                                component="img"

                                src={
                                    obtenerImagen(
                                        comunicadoSeleccionado
                                    )
                                }

                                alt={
                                    comunicadoSeleccionado.titulo
                                }

                                onError={(
                                    event
                                ) => {

                                    event.currentTarget.src =
                                        colegio;

                                }}

                                sx={{
                                    width:
                                        "100%",

                                    height:
                                        "100%",

                                    objectFit:
                                        "cover",
                                }}
                            />


                            {/* DEGRADADO */}

                            <Box
                                sx={{
                                    position:
                                        "absolute",

                                    inset: 0,

                                    background:
                                        "linear-gradient(180deg, rgba(0,0,0,.05) 30%, rgba(0,0,0,.75) 100%)",
                                }}
                            />


                            {/* TIPO */}

                            <Chip
                                label={
                                    obtenerNombreTipo(
                                        comunicadoSeleccionado.tipo
                                    )
                                }

                                sx={{
                                    position:
                                        "absolute",

                                    top: {
                                        xs: 15,
                                        sm: 20,
                                    },

                                    left: {
                                        xs: 15,
                                        sm: 25,
                                    },

                                    bgcolor:
                                        obtenerColorTipo(
                                            comunicadoSeleccionado.tipo
                                        ),

                                    color:
                                        "#fff",

                                    fontWeight:
                                        700,

                                    textTransform:
                                        "uppercase",
                                }}
                            />


                            {/* CERRAR */}

                            <IconButton
                                onClick={
                                    handleCloseDialog
                                }

                                sx={{
                                    position:
                                        "absolute",

                                    top: {
                                        xs: 10,
                                        sm: 15,
                                    },

                                    right: {
                                        xs: 10,
                                        sm: 15,
                                    },

                                    bgcolor:
                                        "rgba(0,0,0,.35)",

                                    color:
                                        "#fff",

                                    "&:hover":
                                        {
                                            bgcolor:
                                                "rgba(0,0,0,.55)",
                                        },
                                }}
                            >

                                <CloseRounded />

                            </IconButton>


                            {/* TÍTULO */}

                           

                        </Box>


                        {/* ==================================================
                            CONTENIDO
                        ================================================== */}

                        <DialogContent
                            sx={{
                                p: {
                                    xs: 3,
                                    sm: 4,
                                    md: 5,
                                },
                            }}
                        >

                            {/* FECHA */}

                            {comunicadoSeleccionado.fecha && (

                                <Stack
                                    direction="row"
                                    spacing={1}
                                    alignItems="center"
                                    mb={3}
                                >

                                    <CalendarMonthOutlined
                                        sx={{
                                            color:
                                                obtenerColorTipo(
                                                    comunicadoSeleccionado.tipo
                                                ),

                                            fontSize:
                                                22,
                                        }}
                                    />

                                    <Typography
                                        sx={{
                                            color:
                                                "#777",

                                            fontSize:
                                                {
                                                    xs: ".85rem",
                                                    sm: ".95rem",
                                                },
                                        }}
                                    >
                                        {
                                            formatearFecha(
                                                comunicadoSeleccionado.fecha
                                            )
                                        }
                                    </Typography>

                                </Stack>

                            )}


                            <Divider
                                sx={{
                                    mb: 3,
                                }}
                            />


                            {/* TÍTULO */}

                            <Typography
                                sx={{
                                    color:
                                        "#561C33",

                                    fontWeight:
                                        700,

                                    fontSize:
                                        {
                                            xs: "1.2rem",
                                            sm: "1.5rem",
                                        },

                                    mb: 2,
                                }}
                            >
                               { comunicadoSeleccionado.titulo}
                            </Typography>


                            {/* DESCRIPCIÓN */}

                            <Typography
                                sx={{
                                    color:
                                        "#666",

                                    lineHeight:
                                        1.9,

                                    fontSize:
                                        {
                                            xs: ".9rem",
                                            sm: "1rem",
                                            md: "1.05rem",
                                        },

                                    whiteSpace:
                                        "pre-line",
                                }}
                            >
                                {
                                    comunicadoSeleccionado.contenido ||
                                    comunicadoSeleccionado.pie_portada ||
                                    "No hay información disponible."
                                }
                            </Typography>

                        </DialogContent>

                    </>

                )}

            </Dialog>

        </Box>

    );

};

